"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Filing = _interopRequireDefault(require("./../Icons/Filing"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function backgroundColor(status, theme) {
  if (status === 'done') {
    return theme.brand.primary;
  }
}

function borderColor(status, theme) {
  switch (status) {
    case 'active':
      return theme.brand.primary;

    case 'disabled':
      return theme.ui.disabled;

    default:
      break;
  }
}

function iconColor(status, theme) {
  switch (status) {
    case 'done':
      return '#FFFFFF';

    case 'active':
      return theme.brand.primary;

    case 'disabled':
      return theme.ui.disabled;

    default:
      break;
  }
}
/**
 * Checks actual stage status
 * @param {string} stage
 */


var getStatus = function getStatus(activeId, stage) {
  if (activeId === stage.id) {
    return 'active';
  } else if (stage.id < activeId) {
    return 'done';
  } else {
    return 'disabled';
  }
};

var Status = _styledComponents.default.div.withConfig({
  displayName: "Status"
})(["display:flex;align-items:center;position:relative;@media (max-width:768px){display:", ";justify-content:center;width:auto;}&::after{content:'", "';display:block;position:absolute;text-align:center;left:50%;transform:translateX(-50%);top:5.76vh;font-size:calc(9px + 0.26vw);line-height:18px;text-transform:capitalize;margin-top:1.8vh;color:", ";width:5vw;}"], function (_ref) {
  var status = _ref.status;
  return status !== 'active' ? 'none' : 'flex';
}, function (_ref2) {
  var name = _ref2.name;
  return name || '';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.labels.defaultText;
});

var StyledIcon = _styledComponents.default.div.withConfig({
  displayName: "StyledIcon"
})(["background-color:", ";display:flex;border-radius:50%;width:40px;height:39px;padding:2px;justify-content:center;align-items:center;box-sizing:border-box;border:", ";border-color:", ";path{fill:", ";stroke:", ";}"], function (_ref4) {
  var status = _ref4.status,
      theme = _ref4.theme;
  return backgroundColor(status, theme) || '#FFFFFF';
}, function (_ref5) {
  var status = _ref5.status;
  return status !== 'done' ? '2.26px solid' : 'none';
}, function (_ref6) {
  var status = _ref6.status,
      theme = _ref6.theme;
  return borderColor(status, theme) || 'transparent';
}, function (_ref7) {
  var status = _ref7.status,
      theme = _ref7.theme;
  return iconColor(status, theme) || '#FFFFFF';
}, function (_ref8) {
  var status = _ref8.status,
      theme = _ref8.theme;
  return iconColor(status, theme) || '#FFFFFF';
});

StyledIcon.displayName = 'StyledIcon';

var TrackingStep = function TrackingStep(_ref9) {
  var activeId = _ref9.activeId,
      stage = _ref9.stage;
  var status = getStatus(activeId, stage);
  return /*#__PURE__*/_react.default.createElement(Status, {
    status: status,
    name: stage.name
  }, /*#__PURE__*/_react.default.createElement(StyledIcon, {
    status: status
  }, stage.icon));
};

var StyledTrackingStep = (0, _styledComponents.default)(TrackingStep).withConfig({
  displayName: "StyledTrackingStep"
})(["display:flex;justify-content:space-around;margin:4vh auto 0.55vh;position:relative;@media (max-width:1200px){margin:0;}"]);
StyledTrackingStep.displayName = 'TrackingStep';
TrackingStep.defaultProps = {
  activeId: 1,
  stage: {
    key: 'filing',
    name: 'filing',
    icon: /*#__PURE__*/_react.default.createElement(_Filing.default, null),
    id: 1
  }
};
TrackingStep.propTypes = {
  activeId: _propTypes.number,
  stage: (0, _propTypes.shape)({
    key: _propTypes.string,
    name: _propTypes.string,
    icon: _propTypes.node,
    id: _propTypes.number
  })
};
var _default = StyledTrackingStep;
exports.default = _default;